module.exports = __webpack_public_path__ + "img/p159_reset.2a0fd8fa.png";